import en from 'i18n/job_profile_skills.en.json'
import nb from 'i18n/job_profile_skills.nb.json'
import { getCategories } from 'utils/categories'

const SKILLS = { en, nb }

export const SKILLS_SECTION_TITLE = {
  en: 'Skills',
  nb: 'Kompetanser',
}

export const getJobProfileSkillCategories = language => {
  const skills = SKILLS[language] || SKILLS.en
  const grouped = Object.entries(skills).reduce(
    (acc, [key, { category, label }]) => {
      if (!acc[category]) acc[category] = []
      acc[category].push({ key, label })
      return acc
    },
    {},
  )

  return getCategories(skills).map(category => ({
    category,
    skills: grouped[category] || [],
  }))
}
